export default __webpack_public_path__ + "static/collaborative-a83e10cfe7c31d3a13c5b0803e9693b5.png";